import { IFieldConfig } from "@shared/lib/types/briefInfluencerV2";

export interface PerformanceFieldCategoryGroup {
  category: string;
  fields: IFieldConfig[];
}

export function groupPerformanceFieldsByCategory(
  fields: IFieldConfig[]
): PerformanceFieldCategoryGroup[] {
  const groups = new Map<string, IFieldConfig[]>();

  fields.forEach((field) => {
    const category = field.category?.trim() || "Other";
    const existing = groups.get(category) || [];
    existing.push(field);
    groups.set(category, existing);
  });

  return Array.from(groups.entries()).map(([category, categoryFields]) => ({
    category,
    fields: categoryFields,
  }));
}

export function getCategorySelectionState(
  fields: IFieldConfig[],
  isVisible: (field: IFieldConfig) => boolean
) {
  const visibleCount = fields.filter(isVisible).length;

  if (visibleCount === 0) {
    return { checked: false, indeterminate: false };
  }

  if (visibleCount === fields.length) {
    return { checked: true, indeterminate: false };
  }

  return { checked: false, indeterminate: true };
}
